export default __webpack_public_path__ + "static/media/icon-refresh.31541675.svg";